export const performanceNow: () => DOMHighResTimeStamp =
	(typeof window !== 'undefined' &&
		window.performance &&
		window.performance.now.bind(performance)) ||
	Date.now;
